import { render, staticRenderFns } from "./updateinfo.vue?vue&type=template&id=a8a57740"
import script from "./updateinfo.vue?vue&type=script&lang=js"
export * from "./updateinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports